import axios from "axios";
import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const GENERAL = `${API_URL}/api/v1/documentos/`;

export async function getDatoListaDocumentos(idSol) {
  try {
    const res = await axios.get(`${GENERAL}${idSol}`);
    return Array.isArray(res.data) ? res.data : [];
  } catch (error) {
    // En 403 (o cualquier error), devuelves []
    return [];
  }
}
export async function verDocumentoPDF(idSol, idDocumento) {
  return await axios({
    method: "GET",
    url: `${GENERAL}${idSol}/${idDocumento}`,
    responseType: "blob",
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo al recoger los PDF de los ducumentos")
    );
}

export async function deleteDocumento(idSol, idDocumento) {
  return await axios({
    method: "DELETE",
    url: `${GENERAL}${idSol}/eliminar/${idDocumento}`,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo al elminar el documento")
    );
}
export async function sendDocumento(idSol, archivo) {
  // Crear una instancia de FormData
  const formData = new FormData();

  // Agregar el archivo al FormData
  formData.append("file", archivo[1]);
  
  return await axios({
    method: "POST",
    url: `${GENERAL}${idSol}/${archivo[0]}`,
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  }).then((res) => res.data);
}
